<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div
    class="kosher-certificates-page"
    :class="{ mobile: isMobile() }"
    data-cy="kosher-certificates-page"
  >
    <MasterPage :subApplication="SubApplicationTypes.LOC">
      <template v-if="!isMobile() && hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left" data-cy="page-title">
            KOSHER CERTIFICATES<small>Letters of Certification - LOC</small>
          </h1>
        </header>
        <KosherCertificatesView />
        <GlobalFooter />
      </template>
      <template v-else-if="hasAccess" v-slot:content>
        <div class="mobile-title-container">
          <span class="mobile-title" data-cy="ukd-products-page-title"
            >Kosher Certificates</span
          >
          <span class="mobile-title-small">Letters of Certification - LOC</span>
        </div>
        <KosherCertificatesMobileView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import { useMainStore } from "@/stores/useMainStore";
import GlobalFooter from "@/views/GlobalFooter.vue";
import KosherCertificatesView from "@/views/kosherCertificates/KosherCertificatesView.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { type RoleGroup, LocAppGroup } from "@/shared/access/RoleGroups";
import { ref } from "vue";
import { SubApplicationTypes } from "@/Domain/SubApplicationTypes";
import KosherCertificatesMobileView from "@/views/kosherCertificates/KosherCertificatesMobileView.vue";
import { isMobile } from "../../shared/helpers/mobileHelper";

const main = useMainStore();

const roleGroups = [
  LocAppGroup,
  {
    roles: [],
    validateRestrictionsAsync: async () => {
      return (
        !main.companySummary?.onLocHold &&
        main.companySummary?.denials.every(
          (d) => !d.LOC || d.LOC.toUpperCase() !== "ALL"
        )
      );
    },
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.mobile-title-container {
  padding: 5px 15px;
  font-size: 11px;
  background: #222;

  .mobile-title {
    font-weight: bold;
    color: white;
    font-size: 12px;
    display: block;
  }

  .mobile-title-small {
    font-weight: 200;
    font-size: 10px;
    color: #ccc;
    display: block;
  }
}
</style>
